import EnumSet from 'Services/enumSet'

interface IOnboardingTypes extends EnumSet {
  none: number
  newUser: number
  newCompany: number
  migrationUser: number
  migrationCompany: number
}

const OnboardingTypes = new EnumSet({
  none: { value: 0, description: 'Indefinido' },
  newUser: { value: 1, description: 'Solicitante novo' },
  newCompany: { value: 2, description: 'Fornecedor novo' },
  migrationUser: { value: 3, description: 'Solicitante migrado' },
  migrationCompany: { value: 4, description: 'Fornecedor migrado' }
}) as IOnboardingTypes

export default OnboardingTypes